// 首页
import request from '@/utils/util.js'

// 获取统计数据
export function getStatisticsDataAPI() {
	return request.get('/admin_statistics')
}
